import $ from 'jquery';

import smootScroll from '../libs/smooth-scroll';
import detectMobile from '../libs/detect-mobile';
import toggleMenu from '../libs/toggle-menu';
import visualSlider from '../libs/visual-slider';
import imageWrapper from '../libs/image-wrapper';
import zoomInImage from '../libs/zoom-in-image';
import megaMenu from '../libs/mega-menu';
import columnScroll from '../libs/column-scroll';
import pageRefresh from '../libs/page-refresh';
import consoleSignature from '../libs/console-signature';
import animazioneTesti from '../libs/animazione-testi';
import lottie from 'lottie-web/build/player/lottie';
import loaderParams from '../libs/lottie/loader-params';
import scrittaCroce from '../libs/lottie/scritta-croce';
import scrittaOrizzontale from '../libs/lottie/scritta-orizzontale';
import scrittaVerticale from '../libs/lottie/scritta-verticale';
import scrittaCollezioni from '../libs/lottie/scritta-collezioni';
// import previewProdotto from '../libs/preview-prodotto';
import template404 from '../libs/404';
import lazyLoad from '../libs/lazy-load';
import playerVideo from '../libs/player-video';
import bloccoInformativoSlider from '../libs/blocco-informativo-slider';
import storytelling from '../libs/storytelling';
import marquee from '../libs/marquee';
import fcbListaProdotti from '../libs/fcb-lista-prodotti';


var animLoader;

export default {
    init() {
        //consoleSignature();
        detectMobile();

        //var animLoader;
        var animationData = loaderParams();

        var params = {
            container: document.getElementById('loadingLottie'),
            renderer: 'svg',
            loop: false,
            autoplay: false,
            animationData: animationData
        };


        $('#loadingLottie').hide();

        animLoader = lottie.loadAnimation(params);


        $('#loadingLottie').fadeIn();
    },

    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //aos();


        visualSlider();
        smootScroll();
        toggleMenu();
        zoomInImage();
        megaMenu();
        pageRefresh();
        // previewProdotto();
        template404();
        scrittaCroce();
        scrittaOrizzontale();
        scrittaVerticale();
        scrittaCollezioni();
        playerVideo();
        bloccoInformativoSlider();
        storytelling();
        marquee();
        fcbListaProdotti();

        $(document).ready(function () {
            setTimeout(function () {
                animLoader.play();
                setTimeout(function () {
                    $('body').addClass('loaded');
                    lazyLoad();
                    setTimeout(function () {
                        $('body').addClass('scrollable');
                        $('#loadingLottie').fadeOut();
                        setTimeout(function () {
                            lottie.destroy(animLoader);
                            animLoader.stop();
                        }, 2000);
                        animazioneTesti();
                        imageWrapper();
                        columnScroll();
                    }, 600);
                }, 1600);
            }, 500);

        });

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js